if (!customElements.get('g-affiliate-list')) {
  class GAffiliateList extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        wrapper: '.g-affiliate-list__wrapper',
      };
    }

    connectedCallback() {
      this.domNodes = queryDomNodes(this.selectors, this);
      const enableSlider = this.dataset.enableSlider === 'true';
      this.item = parseInt(this.dataset.item);
      this.itemsTablet = parseInt(this.dataset.itemsTablet);
      if (!enableSlider) return;
      if (!GkifyTheme.config.mqlMobile) {
        this.domNodes.wrapper.classList.remove('swiper-container');
        return;
      }
      // pc不开启轮播
      const wrapper = this.querySelector('[data-wrapper]');
      wrapper.classList.add('swiper-wrapper');

      this.initSlider();
      window.addEventListener('resize', () => {
        this.initSlider();
      });
    }
    initSlider() {
      const $this = this;
      const autoplay = this.dataset.enableAutoplay === 'true';
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector('.swiper-container');
      if (slideContainer) {
        this.slider = new GkifyLibs.Swiper(slideContainer, {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
          loop: true,
          preventClicks: false,
          preventClicksPropagation: false,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: $this.item,
            },
          },
        });
      }
    }
  }

  customElements.define('g-affiliate-list', GAffiliateList);
}
